import React, { useState, useRef, useEffect } from "react";
import ActionBar from "../../common/ActionBar";
import { Formik } from "formik";
import {
  Grid,
  FormControlLabel,
  RadioGroup,
  Radio,
  makeStyles,
  AppBar,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import CreateBulkCaseAudit from "./component/CreateBulkCaseAudit";
import NoticeAudit from "./component/NoticeAudit";
import UploadAudit from "./component/UploadAudit";
import { Icon } from "../PaymentHistoryPage";
import labels from "../../../helpers/labels.json";
import PropTypes from "prop-types";
import _ from "lodash";
import { navigate } from "@reach/router";
import { fadeIn } from "../../Mis/styles";
import useUser from "../../../hooks/useUser";
import PartyService from "../../../services/PartyService";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <StyledText style={{ height: "100%" }}>{children}</StyledText>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  overflow: auto;
`;

const radio_inputs = [
  {
    label: "Maker",
    name: "maker",
    value: "maker",
  },
  {
    label: "Checker",
    name: "checker",
    value: "checker",
  },
];

const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  root: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 46px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },

  appBar: {
    color: COLORS.COLOR_DARK,
    boxShadow: "none",
    background: "transparent",
    fontFamily: theme.fonts.primaryFontBold,
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
      [themes.breakpoints.up(640)]: {
        justifyContent: "flex-start",
      },
    },
  },

  label: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 80,
    [themes.breakpoints.up(400)]: {
      width: "auto",
      maxWidth: 230,
    },
  },
}));

export default function FinalApprover() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  const { userObject } = useUser();
  const MTRef = useRef();
  const [agents, setAgents] = useState([]);
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    async function getParties(params) {
      try {
        setLoader({ state: true });
        const response = await PartyService.getParties(
          "?perPage=4000&status=active&allAgents=true",
        );
        if (response?.data?.length) {
          setAgents(
            response?.data
              ?.map(({ agents }) => {
                return agents;
              })
              .flat(),
          );
        } else {
          enqueueSnackbar(
            "You need to create a Party inorder to create a case",
            {
              variant: "error",
              autoHideDuration: 3000,
            },
          );
        }
      } catch (error) {
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
    getParties();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "dashboard":
        navigate("/dashboard");
        break;
      default:
        break;
    }
  };

  return (
    <div className="paymentHistory">
      <ActionBar
        breadcrumbs={["Dashboard", "Final Approver"]}
        {...{ onBreadcrumbClick }}
      />

      <Formik
        initialValues={{
          auditor: "maker",
        }}
        enableReinitialize
        validateOnBlur
        validateOnChange
        onSubmit={"onFormSubmit"}
      >
        {({
          values,
          handleChange,
          errors,
          handleSubmit,
          touched,
          setFieldValue,
          setFieldError,
          handleBlur,
          isValid,
        }) => (
          <form>
            <Grid
              className={classes.radioRoot}
              item
              xs={12}
              spacing={2}
              style={{ marginTop: "5px", padding: 16 }}
            >
              <RadioGroup
                style={{
                  flexDirection: "row",
                  marginLeft: "10px",
                }}
                name={"auditor"}
                value={values.auditor}
                onChange={(e) => {
                  setFieldValue("auditor", e.target.value);
                  MTRef.current.onQueryChange(MTRef?.current?.state?.query);
                }}
              >
                {radio_inputs.map((radio, key) => (
                  <FormControlLabel
                    {...{ key }}
                    classes={{ label: classes.formLabel }}
                    value={radio.value}
                    control={
                      <Radio size="medium" style={{ color: "#00838c" }} />
                    }
                    label={radio.label}
                  />
                ))}
              </RadioGroup>
            </Grid>
            <div className={classes.root}>
              <AppBar className={classes.appBar} position="static">
                <Tabs
                  value={value}
                  indicatorColor="primary"
                  onChange={(_, newValue) => setValue(newValue)}
                  aria-label="pending-action-tab"
                >
                  <Tab
                    label={
                      <div className={classes.label}>
                        {labels.create_bulk_case}
                      </div>
                    }
                    icon={
                      !isBigScreen ? (
                        value === 0 ? (
                          <Icon
                            src={require("../../../assets/images/credit-card-active.svg")}
                          />
                        ) : (
                          <Icon
                            src={require("../../../assets/images/credit-card-inactive.svg")}
                          />
                        )
                      ) : (
                        ""
                      )
                    }
                    {...a11yProps(0)}
                  />
                  <Tab
                    label={
                      <div className={classes.label}>
                        {labels.notice_generation}
                      </div>
                    }
                    icon={
                      !isBigScreen ? (
                        value === 1 ? (
                          <Icon
                            src={require("../../../assets/images/invoice-active.svg")}
                          />
                        ) : (
                          <Icon
                            src={require("../../../assets/images/invoice-inactive.svg")}
                          />
                        )
                      ) : (
                        ""
                      )
                    }
                    {...a11yProps(1)}
                  />
                  <Tab
                    label={
                      <div className={classes.label}>
                        {labels.document_upload}
                      </div>
                    }
                    icon={
                      !isBigScreen ? (
                        value === 2 ? (
                          <Icon
                            src={require("../../../assets/images/refund-active.svg")}
                          />
                        ) : (
                          <Icon
                            src={require("../../../assets/images/refund-inactive.svg")}
                          />
                        )
                      ) : (
                        ""
                      )
                    }
                    {...a11yProps(2)}
                  />
                </Tabs>
              </AppBar>

              <TabPanel value={value} index={0}>
                {userObject?.id && (
                  <CreateBulkCaseAudit
                    auditor={values.auditor}
                    id={userObject?.id}
                    {...{ MTRef }}
                  />
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                <NoticeAudit
                  auditor={values.auditor}
                  id={userObject?.id}
                  {...{ MTRef, agents }}
                />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <UploadAudit
                  auditor={values.auditor}
                  id={userObject?.id}
                  {...{ MTRef }}
                />
              </TabPanel>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
}

export const TableWrapper = styled.div`
  animation: ${fadeIn} 0.8s ease-in-out;
`;
